<template>
    <div class="min-h-screen bg-secondary flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <h2 class="flex justify-center mt-6 text-3xl font-extrabold text-gray-900">
                <img src="/media/logo.png" class="h-24 w-auto" />
            </h2>
        </div>

        <div class="mt-12 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>
